exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.page-controller-view[data-v-79b236f8]{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-flex:1;-webkit-flex:1;flex:1\n}", "", {"version":3,"sources":["/home/ylp/ylp-leadmall-c/src/components/app/dataController.vue"],"names":[],"mappings":";AACA,uCAAuC,oBAAoB,qBAAqB,aAAa,mBAAmB,eAAe,MAAM;CACpI","file":"dataController.vue","sourcesContent":["\n.page-controller-view[data-v-79b236f8]{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-flex:1;-webkit-flex:1;flex:1\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79b236f8","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/after-less-loader.js!./node_modules/less-loader?{"sourceMap":true}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app/dataController.vue
// module id = 5v5B
// module chunks = 1